<template>
  <div>
    <!-- Select driver -->
    <div v-if="availableDrivers && availableDrivers.length > 0" class="mb-6">
      <hr class="my-6 border-base-300" />
      <p class="flex items-center mb-2">Pasirinkite vairuotoją:</p>
      <table class="table">
        <!-- Table Headings -->
        <thead>
          <tr>
            <th class="w-16"></th>
            <th>Vardas, Pavardė</th>
            <th>Tel. nr.</th>
            <th>El. paštas</th>
            <th>Užimtumas</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="driver in availableDrivers"
            :key="driver.id"
            :class="[
              selectedDriverId === driver.id
                ? 'bg-primary-content'
                : 'bg-base-100',
            ]"
          >
            <td class="w-16">
              <DefaultIcon
                @click="selectDriver(driver)"
                name="plus"
                size="w-6 h-6"
                class="btn btn-circle btn-ghost btn-sm text-primary"
              />
            </td>
            <td>{{ driver.name }} {{ driver.surname }}</td>
            <td>{{ driver.phone }}</td>
            <td>{{ driver.email }}</td>
            <td>
              <ol v-if="driver.occupied_times.length > 0">
                <li
                  v-for="(occupied_time, index) in driver.occupied_times"
                  :key="index"
                >
                  {{ occupied_time.time_start }}-{{ occupied_time.time_finish }}
                </li>
              </ol>

              <div v-else>Laisva visą dieną</div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Empty state -->
    <div v-else class="py-4 text-base-content/60">
      Nurodytai datai ir pasirinktai transporto priemonei laisvų vairuotojų
      nerasta. Bandykite pasirinkti kitą transporto priemonę, datą.
    </div>
  </div>
</template>
<script setup>
import { defineEmits, defineProps } from "vue";
import DefaultIcon from "@/components/icons/DefaultIcon.vue"; // Adjust path as needed

defineProps({
  availableDrivers: {
    type: Array,
    default: () => [],
  },
  selectedDriverId: {
    type: [Number, String, null],
    default: null,
  },
});

const emit = defineEmits(["select-driver"]);

// Function to select a driver and emit the selection
const selectDriver = (driver) => {
  emit("select-driver", driver);
};
</script>
